import Timeout from '../lib/Timeout.js';
import Promise from '../lib/Promise.js';

class ActiveTabWarningTask {
    static async run(params) {
        return new ActiveTabWarningTask(params).run();
    }

    constructor({env}) {
        this.env = env;
    }

    getLastActive() {
        return this.env.getLastActiveTimeStamp();
    }

    hasActiveTab() {
        var initialLastActive = this.getLastActive(),
            lastActiveRefreshed = () => this.getLastActive() > initialLastActive;

        if (initialLastActive === null || (Date.now() - initialLastActive > 5000)) {
            return Promise.resolve(false);
        }

        return Promise.create(resolve => {
            var timeout = Timeout.seconds(5).then(() => {
                window.removeEventListener('storage', storageListener);
                resolve(false);
            });

            window.addEventListener('storage', storageListener);

            function storageListener() {
                if (lastActiveRefreshed()) {
                    timeout.clear();
                    resolve(true);
                }
            }
        });
    }

    async run() {
        if (await this.hasActiveTab()) {
            await this.env.showDialog('already-logged-in-dialog');
        }
    }
}

export default ActiveTabWarningTask;